export default function imagevalidators(e) {
  var { files } = e.target;

  if (files.length === 1) {
    let file = files[0];
    if (file.size >41943040) 
      return "Pic size is more then 4 MB Please Upload pic upto 4 mb";
    else if (
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/webp" ||
      file.type === "image/png" ||
      file.type === "image/gif"
    )
      return "";
    else return "Invalid Pic";
  } else {
    let error = [];
    for (let index in Array.from(files)) {
      let file = files[index];
      if (file.size > 3145728)
        error.push(`Pic${parseInt(index)+1} size is more then 3 MB, Please Upload pic upto 3 MB`);
      else if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/webp" ||
        file.type === "image/png" ||
        file.type === "image/gif"
      ){}
        // error.push("");
      else error.push(`Invalid Pic${parseInt(index)+1}`);
    }
    return error.length?error.length:"" 
  }
}
